import { render, staticRenderFns } from "./PatientControlIdentification.vue?vue&type=template&id=5d8dabea&scoped=true&"
import script from "./PatientControlIdentification.vue?vue&type=script&lang=ts&"
export * from "./PatientControlIdentification.vue?vue&type=script&lang=ts&"
import style0 from "./PatientControlIdentification.vue?vue&type=style&index=0&id=5d8dabea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8dabea",
  null
  
)

export default component.exports